"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/* eslint-disable react/no-find-dom-node */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_dom_1 = require("react-dom");

var react_dnd_1 = require("react-dnd");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");
/** Props appended to the drop target */


var connectDT = function connectDT(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
};
/** Methods triggered when Element is dropped **/


var dropTargetSpec = {
  drop: function drop(props, monitor) {
    return {
      currentIndex: monitor.getItem().ruleIndex,
      newIndex: props.dropIndex
    };
  }
};
/**
 * Separator between ruleComponents also acts as a dropzone
 **/

var RuleSeparator =
/** @class */
function (_super) {
  __extends(RuleSeparator, _super);

  function RuleSeparator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RuleSeparator.prototype.render = function () {
    var _a = this.props,
        connectDropTarget = _a.connectDropTarget,
        canDrop = _a.canDrop,
        isOver = _a.isOver;
    var isActive = canDrop && isOver;
    return react_1.default.createElement("div", {
      ref: function ref(instance) {
        var node = react_dom_1.findDOMNode(instance);
        connectDropTarget(node);
      },
      className: ca_ui_toolkit_1.classnames('vis-cf-rule-separator', {
        'vis-cf-is-active': isActive
      })
    });
  };

  RuleSeparator = __decorate([react_dnd_1.DropTarget('Rules', dropTargetSpec, connectDT)], RuleSeparator);
  return RuleSeparator;
}(react_1.Component);

exports.default = RuleSeparator;
